import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiConfig } from './api-config';
import { DynamicField } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CoApplicantsService {

  constructor(private http: HttpClient) { }

  getAll(subdomain: string): Observable<string[]> {
    const url = ApiConfig.getApiUrl('/co_applicants/groups.json', subdomain);
    return this.http.get<string[]>(url, { withCredentials: true });
  }
}
